import {Component, OnDestroy, OnInit} from '@angular/core';
import {PharmacyAdministrationComponent} from '../pharmacy-administration/pharmacy-administration.component';
import {DoctorAdministrationComponent} from '../doctor-administration/doctor-administration.component';
import {PracticeAdministrationComponent} from '../practice-administration/practice-administration.component';
import {
    AdministrationArchiveComponent
} from '../administration/administration-archive/administration-archive.component';
import {AdministrationTemplatesComponent} from '../administration-templates/administration-templates.component';
import {MatTabsModule} from '@angular/material/tabs';

@Component({
    selector: 'app-app-administration',
    imports: [
        PharmacyAdministrationComponent,
        DoctorAdministrationComponent,
        PracticeAdministrationComponent,
        AdministrationArchiveComponent,
        AdministrationTemplatesComponent,
        MatTabsModule
    ],
    templateUrl: './app-administration.component.html',
    styleUrl: './app-administration.component.sass'
})
export class AppAdministrationComponent implements OnInit, OnDestroy {
    activeMenu: string = 'templates';

    constructor(
    ) {
    }

    ngOnInit() {

    }

    ngOnDestroy() {
    }

    setMenu(menu: string): void {
        this.activeMenu = menu;
    }

}
